/**
 * 语言状态管理（单例）
 * - current: 当前语言（默认从 localStorage 取，否则 zh_CN）
 * - available: 可用语言列表（GetForNewForm 返回后更新）
 * - switch(lang): 切换语言并写 localStorage，触发页面刷新
 */
const STORAGE_KEY = "current_i18n";

class LangManager {
  constructor() {
    this._current = window.localStorage.getItem(STORAGE_KEY) || "zh_CN";
    this._available = ["zh_CN"];
    this._listeners = [];
  }

  get current() {
    return this._current;
  }

  set current(lang) {
    this._current = lang;
    window.localStorage.setItem(STORAGE_KEY, lang);
  }

  get available() {
    return this._available;
  }

  setAvailable(langs) {
    console.log("[mtv-i18n] LangManager.setAvailable called with:", langs);
    console.log("[mtv-i18n] current listeners count:", this._listeners.length);
    if (Array.isArray(langs) && langs.length > 0) {
      this._available = langs;
      // 如果当前语言不在可用列表中，回退到 zh_CN
      if (this._available.indexOf(this._current) < 0) {
        this._current = "zh_CN";
        window.localStorage.setItem(STORAGE_KEY, this._current);
      }
      console.log("[mtv-i18n] _available updated, calling _emitChange");
      // 通知订阅者（如 Header 组件）
      this._emitChange();
    } else {
      console.log("[mtv-i18n] WARN: langs is empty or not array, skip");
    }
  }

  /** 通知所有监听器 langs 已更新 */
  _emitChange() {
    var snapshot = {
      current: this._current,
      available: this._available.slice(),
      enabled: this.enabled,
    };
    console.log(
      "[mtv-i18n] _emitChange snapshot:",
      snapshot,
      "notifying",
      this._listeners.length,
      "listeners"
    );
    this._listeners.forEach(function (fn) {
      try {
        fn(snapshot);
      } catch (e) {
        console.error("[mtv-i18n] listener error:", e);
      }
    });
  }

  /** 是否启用了多语言（多于一种） */
  get enabled() {
    return this._available.length > 1;
  }

  /** 切换语言：写 localStorage 并刷新页面 */
  switch(lang) {
    if (lang === this._current) return;
    this.current = lang;
    // 重新加载页面（简单可靠，重新挂载 i18n + 重新拉数据）
    window.location.reload();
  }

  /** 仅切换内存中语言（不刷新页面，需调用方手动触发 i18n.locale 更新和响应式刷新） */
  switchSilent(lang) {
    this.current = lang;
    this._listeners.forEach((fn) => {
      try {
        fn(lang);
      } catch (e) {
        /* noop */
      }
    });
  }

  onChange(fn) {
    if (typeof fn === "function") this._listeners.push(fn);
    // 返回 unsubscribe 函数
    var self = this;
    return function unsubscribe() {
      var idx = self._listeners.indexOf(fn);
      if (idx >= 0) self._listeners.splice(idx, 1);
    };
  }
}

export default new LangManager();
